module.exports = function getResource(label, vars = []) {
    let resources = {
        myBasketLabel: 'My Basket',
        yourBasketLabel: 'Your Baskets'
    };

    return resources[label];
};
